import PropTypes from 'prop-types';

export const EmailTriggersPropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    triggerText: PropTypes.string.isRequired,
  }),
);
